var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showError)?_c('v-chip',{staticClass:"ml-2",attrs:{"small":"","label":"","color":"error"}},[_vm._v(" Erro pgto ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }